import React from "react";
import InputForm from "./component/InputForm";  // This path should be correct

import "./App.css";

function App() {
  return (
    <div className="App">
      <h1>Healthcare Dashboard</h1>
      <InputForm />
    </div>
  );
}

export default App;
